module.exports = __webpack_public_path__ + "media/images/index-vr-bg-a26a5d4bacc5201fc9675155fbc98546.jpg";